/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatVolume'
})
export class FormatVolumePipe implements PipeTransform {

  transform(value: any, fractionDigits = 3, ...args: any[]): any {
    return Math.ceil(value * Math.pow(10, 3)) / Math.pow(10, 3);
  }

}
